import axios from 'axios';
import Service from '@/api/service'

axios.defaults.baseURL = process.env.API_URL

/*
    using '...Service('/url/:id/')' in object provides methods:
        fetch
        get
        delete
        put
        save
 */

export const SiteSettings = {
    update: (payload) => {
        return axios.put('/core/admin/settings/', payload)
    },
    get: (payload) => {
        return axios.get('/core/admin/settings/', payload)
    },
    refresh () {
        return axios.get('/core/admin/refresh-frontend/')
    }
}

export const Stage = {
    ...Service('/stages/admin/:id/'),
    changeOrder (payload) {
        return axios.post('/stages/admin/set_order/', payload)
    }
}

export const Edition = {
    ...Service('/core/editions/:id/')
}

export const Color = {
    ...Service('/core/colors/:id/')
}

export const Stand = {
    ...Service('/stands/admin/:id/'),
    tags () {
        return axios.get('/stands/admin/tags/')
    }
}

export const StandCategory = {
    ...Service('/stands/admin/categories/:id/')
}

export const Attachment = {
    ...Service('/attachments/:id/'),
    upload: (payload) => {
        return axios.post('/attachments/', payload, {
                headers: {'content-type': 'multipart/form-data'}
            }
        )
    }
}

export const Popup = {
    ...Service('/popups/:id/'),
    all () {
        return axios.get('/popups/all/')
    }
}

export const Page = {
    ...Service('/pages/admin/:slug/'),
    slug (id, payload) {
        return axios.put(`/pages/admin/slug/${id}/`, payload)
    }
}

export const InstagramFolder = {
    ...Service('/instagram/:id/'),
    remote (payload) {
        return axios.get('/instagram/remote/', payload)
    },
    all () {
        return axios.get('/instagram/all/')
    }
}

export const Occurrence = {
    fetch (params, payload) {
        return axios.get('/events/spectacles/occurrences/', payload)
    },
    exportUrl (id) {
        return `${axios.defaults.baseURL}events/spectacles/occurrences/${id}/export/`
    }
}

export const Registration = {
  ...Service('/events/spectacles/registrations/:id/'),
}

export const ArtistsListWidget = {
    preview (payload) {
        return axios.post('/artists-list-widget/preview/', payload)
    }
}

export const Concert = {
    ...Service('/events/concerts/:id/'),
    tags () {
        return axios.get('/events/concerts/tags/')
    },
    changeOrder (payload) {
        return axios.post('/events/concerts/change_order/', payload)
    },
    getOrder (payload) {
        return axios.get('/events/concerts/get_order/', payload)
    }
}

export const Spectacle = {
    ...Service('/events/spectacles/:id/'),
    tags () {
        return axios.get('/events/spectacles/tags/')
    },
    changeOrder (payload) {
        return axios.post('/events/spectacles/change_order/', payload)
    },
    getOrder (payload) {
        return axios.get('/events/spectacles/get_order/', payload)
    }
}

export const Film = {
    ...Service('/events/films/:id/'),
    tags () {
        return axios.get('/events/films/tags/')
    },
    changeOrder (payload) {
        return axios.post('/events/films/change_order/', payload)
    },
    getOrder (payload) {
        return axios.get('/events/films/get_order/', payload)
    }
}

export const Widget = {
    ...Service('/widgets/:id/'),
    types (params) {
        return axios.get('/widgets/types/', {params})
    },
    validate (payload) {
        return axios.post('/widgets/validate/', payload)
    },
    available (params) {
        return axios.get('/widgets/available/', {params})
    },
}

export const Menu = {
    ...Service('/menu/admin/:id/'),
    availableLinkOptions () {
        return axios.get('/menu/available-options/')
    }
}

export const Tag = {
    availableTags () {
        return axios.get('/events/available-tags/')
    }
}

export const OtherEvent = {
    ...Service('/events/others/:id/'),
    tags () {
        return axios.get('/events/others/tags/')
    },
    eventTypes () {
        return axios.get('/events/others/event_types/')
    },
    changeOrder (payload) {
        return axios.post('/events/others/change_order/', payload)
    },
    getOrder (payload) {
        return axios.get('/events/others/get_order/', payload)
    }
}

export const Auth = {
    login (payload) {
        return axios.post('/api-token-auth/', payload)
    },
    tokenRefresh (payload) {
        return axios.post('/api-token-refresh/', payload)
    }
}

export const Period = {
    ...Service('/tickets/periods/:id/')
}

export const Ticket = {
    ...Service('/tickets/:id/')
}

export const Image = {
    ...Service('/galleries/admin/images/:id/'),
    all (params) {
        return axios.get('/core/admin/photos/', {params})
    },
}

export const News = {
    ...Service('/news/admin/:id/'),
    tags () {
        return axios.get('/news/admin/tags/')
    }
}

export const Folder = {
    ...Service('/galleries/admin/folders/:id/'),
    all () {
        return axios.get('/galleries/admin/folders/all/')
    }
}


export const CustomForm = {
    ...Service('/forms/admin/:id/'),
    all () {
        return axios.get('/forms/admin/all/')
    },
    fieldTypes () {
        return axios.get('/forms/admin/fields/')
    },
    validateField (payload) {
        return axios.post('/forms/admin/fields/validation', payload)
    },
    clone (id) {
        return axios.post(`/forms/admin/${id}/clone/`)
    },
    fetchFormData: (id) => {
        return axios.get(`/forms/admin/data/${id}/`)
    },
    exportFormData: (id, email) => {
        let baseURL = axios.defaults.baseURL
        if (baseURL[baseURL.length - 1] !== '/') {
            baseURL += '/'
        }
        if (email) {
            return axios.get(`${baseURL}forms/admin/${id}/export/?email=${email}`)
        } else {
            const config = {
                responseType: 'blob'
            }
            return axios.get(`${baseURL}forms/admin/${id}/export/`, config)
        }
    }
}

export const Lounger = {
    ...Service('/admin/loungers/:id/'),
}

export const LoungerReservation = {
    ...Service('/admin/loungers/reservations/:id/'),
    mark_as_paid (id) {
        return axios.post(`/admin/loungers/reservations/${id}/mark_as_paid/`)
    },
    exportUrl () {
        return `${axios.defaults.baseURL}admin/loungers/reservations/export_csv/`
    }
}






// WEBPACK FOOTER //
// ./src/api/index.js